export default class OrderedRequestHelper {
  private lastKey?: string;

  public ordered<T>(request: () => Promise<T>): Promise<T> {
    const key = String(new Date().getTime());
    this.lastKey = key;
    return new Promise<T>((resolve, reject) => {
      request()
        .then((result) => {
          if (key === this.lastKey) {
            resolve(result);
          }
        })
        .catch((error) => {
          if (key === this.lastKey) {
            reject(error);
          }
        });
    });
  }
}
